<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName"
                         placeholder="请输入设备名称"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-form-item>
                <a-button type="primary"
                          @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table bordered
               :data-source="list"
               :columns="columns"
               :scroll="{ x: 1500 }"
               :loading="dataListLoading"
               :pagination="pagination"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               @change="pageChange">
        <span slot="type"
              slot-scope="text">
          <span v-if="text == 0">报警</span>
          <span v-else>故障</span>
        </span>
        <span slot="content"
              slot-scope="text, record">
          {{ record.deviceName }}数据异常 , 异常原因{{ record.malfunctionCause }}
        </span>
        <span slot="actiontype"
              slot-scope="text">
          <span v-if="text == 0"><a-tag color="red">待处理</a-tag></span>
          <span v-else><a-tag color="green">已处理</a-tag></span>
        </span>
        <span slot="malfunctionLevel"
              slot-scope="text">
          <span v-if="text == '忽略'"><a-tag color="cyan">{{ text }}</a-tag></span>
          <span v-else-if="text == '一般'"><a-tag color="blue">{{ text }}</a-tag></span>
          <span v-else-if="text == '中等'"><a-tag color="green">{{ text }}</a-tag></span>
          <span v-else><a-tag color="red">{{ text }}</a-tag></span>
        </span>
      </a-table>
      <!-- <a-table
        size="middle"
        :scroll="{ x: 1100 }"
        :loading="dataListLoading"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        bordered
      >
        <span slot="type" slot-scope="text">
          <span v-if="text == 0">报警</span>
          <span v-else>故障</span>
        </span>
        <span slot="content" slot-scope="text, record">
          {{ record.deviceName }}数据异常 , 异常原因{{ record.malfunctionCause }}
        </span>
        <span slot="actiontype" slot-scope="text">
          <span v-if="text == 0"><a-tag color="red">待处理</a-tag></span>
          <span v-else><a-tag color="green">已处理</a-tag></span>
        </span>
        <span slot="malfunctionLevel" slot-scope="text">
          <span v-if="text == '忽略'"
            ><a-tag color="cyan">{{ text }}</a-tag></span
          >
          <span v-else-if="text == '一般'"
            ><a-tag color="blue">{{ text }}</a-tag></span
          >
          <span v-else-if="text == '中等'"
            ><a-tag color="green">{{ text }}</a-tag></span
          >
          <span v-else
            ><a-tag color="red">{{ text }}</a-tag></span
          >
        </span>
      </a-table> -->
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      id: '',
      showdeal: false,
      queryUrl: '/pipe-network/water_works_malfunctions/page',
      deleteUrl: '/pipe-network/water_works_malfunctions/',
      modifyUrl: '/pipe-network/water_works_malfunctions',
      visible: false,
      confirmLoading: false,
      list: [],
      query: {
        deviceName: '',
        disposeResult: 1,
        sysType: 4,
        tenantId: this.$store.state.user.info.tenantId
      },
      // 分页条
      // pagination: {
      //   current: 1,
      //   pageSize: 10,
      //   total: 0,
      //   showTotal: (total) => `共 ${total} 条记录`,
      //   showSizeChanger: true,
      //   pageSizeOptions: ['10', '20', '50', '100'],
      // },
      typelist: ['重要', '中等', '一般', '忽略'],
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '设备名称',
          width: 100,
          dataIndex: 'deviceName',
          align: 'center'
        },
        {
          title: '参数名称',
          width: 50,
          dataIndex: 'parameterName',
          align: 'center'
        },
        {
          title: '参数值',
          width: 30,
          dataIndex: 'dataValue',
          align: 'center'
        },
        {
          title: '异常信息',
          width: 200,
          dataIndex: 'malfunctionDescribe',
          align: 'center',
          scopedSlots: { customRender: 'content' }
        },
        {
          title: '异常状态',
          width: 40,
          dataIndex: 'malfunctionLevel',
          align: 'center',
          scopedSlots: { customRender: 'malfunctionLevel' }
        },
        {
          title: '是否已处理',
          width: 40,
          dataIndex: 'disposeResult',
          align: 'center',
          scopedSlots: { customRender: 'actiontype' }
        },
        {
          title: '创建时间',
          width: 70,
          dataIndex: 'createTime',
          align: 'center'
        }
      ]
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    }
  },
  mounted () {
    this.queryList()
  },
  methods: {
    handleChange (e) {
      const params = { id: this.id, malfunctionLevel: e }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'put'
      }).then((data) => {
        this.queryList()
        this.visible = false
        this.$message.success('标记成功')
      })
    },
    resetList () {
      this.query = {
        deviceName: '',
        // malfunctionType: 0,
        disposeResult: 1,
        sysType: 4,
        tenantId: this.$store.state.user.info.tenantId
      }
      this.pagination.current = 1
      this.pageQueryList()
    },
    handleSelectChange (value) {
      console.log(value)
      this.addOrUpdateForm.setFieldsValue(value)
    },
    handleDealSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({
        processMode: value
      })
    },
    Deal (id) {
      this.id = id
      // this.addOrUpdateHandle(id);
      this.showdeal = true
    },
    addOrUpdateHandle (id) {
      this.id = id
      this.showModal()
    },
    showModal () {
      this.visible = true
    },
    handleDealOk () {
      console.log(this.id)
      this.form.validateFields((err, values) => {
        if (!err) {
          const year = new Date().getFullYear()
          let month = new Date().getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = new Date().getDate()
          day = day < 10 ? '0' + day : day
          let hour = new Date().getHours()
          hour = hour < 10 ? '0' + hour : hour
          let seconds = new Date().getSeconds()
          seconds = seconds < 10 ? '0' + seconds : seconds
          let minutes = new Date().getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          const now = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
          const params = {
            id: this.id,
            processor: values.processor,
            malfunctionDescribe: values.malfunctionDescribe,
            processMode: values.processMode,
            disposeResult: 1,
            processorTime: now
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token
          }
          this.$http({
            url: this.modifyUrl,
            data: params,
            headers: header,
            method: 'put'
          }).then((data) => {
            this.queryList()
            this.showdeal = false
            this.$message.success('处理成功')
          })
        }
      })
    },
    handleDealCancel () {
      this.showdeal = false
    },
    handleOk () {
      this.visible = false
    },
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
